import { render, staticRenderFns } from "./UploadVideoComp.vue?vue&type=template&id=4ffa9cd8&scoped=true"
import script from "./UploadVideoComp.vue?vue&type=script&lang=ts"
export * from "./UploadVideoComp.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./UploadVideoComp.vue?vue&type=style&index=0&id=4ffa9cd8&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "4ffa9cd8",
  "170ac60a"
  
)

export default component.exports